t = require('views/internal/teacup-with-helpers')('member_list_item_detail')
memberTemplate = require './member'

module.exports = ->
  t.div { class: 'member member-no-menu' + t.mustacheBlock('isVirtual', (-> ' member-virtual')) + t.mustacheBlock('isDeactivated', (-> ' member-deactivated')) }, ->
    memberTemplate t.mustacheVar('.')

  t.div '.details', ->

    t.p '.name-line', ->
      t.span '.full-name', ->
        t.text t.mustacheVar('fullName')

    t.p '.u-bottom.quiet', ->
      t.mustacheBlock 'username', ->
        t.span '.quiet.u-inline-block', ->
          t.format 'at-username', { username: t.mustacheVar('username') }

      t.mustacheBlock 'showGoogleApps', ->
        t.mustacheBlock 'gMail', ->
          t.mustacheBlock 'username', ->
            t.text "- "
          t.icon 'google'
          t.text t.mustacheVar('gMail')

  t.div '.options', ->
    t.mustacheBlock 'isOrgMember', ->
      t.mustacheBlock 'showActivity', ->
        t.a '.option.quiet-button.js-view-activity', { href: '#' }, ->
          t.format 'activity'

      t.mustacheBlock 'allowTypeChange', ->
        t.a '.option.button-link.role-button.js-change-role', { href: '#' }, ->
          t.text t.mustacheVar('orgMemberType')
          t.icon 'overflow-menu-horizontal'
      t.mustacheBlockInverted 'allowTypeChange', ->
        t.p '.option.status.quiet', ->
          t.text t.mustacheVar('orgMemberType')

      t.mustacheBlock 'allowReactivate', ->
        t.a '.option.quiet-button.js-reactivate', { href: '#' }, ->
          t.format 'reactivate'

      t.mustacheBlock 'isMe', ->
        t.a { class: 'option button-link remove-button js-remove-or-deactivate ' + t.mustacheBlockInverted('canRemove', (-> 'disabled')), href: '#' }, ->
          t.mustacheBlock 'orgIsBC', ->
            t.icon 'close', 'leave-ellipsis'
          t.mustacheBlockInverted 'orgIsBC', ->
            t.icon 'close', 'leave'

      t.mustacheBlockInverted 'isMe', ->
        t.mustacheBlock 'ownsOrg', ->
          t.a { class: 'option button-link remove-button js-remove-or-deactivate ' + t.mustacheBlockInverted('canRemove', (-> 'disabled')), href: '#' }, ->
            t.icon 'close', 'remove-ellipsis'

    t.mustacheBlockInverted 'isOrgMember', ->
      t.mustacheBlock 'showGoogleApps', ->
        t.mustacheBlockInverted 'hidden', ->
          t.a '.option.quiet-button.js-hide-member', { href: '#' }, ->
            t.format 'dismiss'
        t.mustacheBlock 'hidden', ->
          t.a '.option.quiet-button.js-unhide-member', { href: '#' }, ->
            t.format 'always-show'
        t.a '.option.button-link.primary.js-invite-to-org', { href: '#' }, ->
          t.icon 'add', 'add-member'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/member_list_item_detail.coffee